import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type SkeletonType = 'login' | 'register' | 'custom';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'sb-loading-skeleton',
  template: `
    <div class="animate-pulse">
      <div class="flex flex-col gap-y-4">
        <!-- Header skeleton -->
        <div class="h-16 bg-gray-200 rounded-lg"></div>

        <!-- Title and subtitle skeleton -->
        <div class="flex flex-col justify-center items-center gap-y-1">
          <div class="h-8 bg-gray-200 rounded w-32"></div>
          <div class="h-4 bg-gray-200 rounded w-48"></div>
        </div>
      </div>

      <div class="mt-8 space-y-6">
        <!-- Error alert skeleton -->
        <div class="h-4 bg-gray-200 rounded w-full"></div>

        <!-- Form fields skeleton -->
        <div class="flex flex-col gap-y-4">
          @if (type() === 'register') {
          <!-- Register form layout -->
          <div class="grid grid-cols-2 gap-4">
            <div class="h-12 bg-gray-200 rounded"></div>
            <div class="h-12 bg-gray-200 rounded"></div>
          </div>
          <div class="h-12 bg-gray-200 rounded"></div>
          <div class="h-12 bg-gray-200 rounded"></div>
          <div class="h-12 bg-gray-200 rounded"></div>
          <div class="h-12 bg-gray-200 rounded"></div>
          } @else if (type() === 'login') {
          <!-- Login form layout -->
          <div class="h-12 bg-gray-200 rounded"></div>
          <div class="h-12 bg-gray-200 rounded"></div>
          } @else {
          <!-- Custom layout - render custom fields -->
          @for (field of customFields(); track $index) { @if (field.type ===
          'grid') {
          <div class="grid gap-4" [ngClass]="'grid-cols-' + field.columns">
            @for (item of getArrayFromNumber(field.items || 1); track $index) {
            <div class="h-12 bg-gray-200 rounded"></div>
            }
          </div>
          } @else {
          <div
            [ngClass]="
              'h-' +
              field.height +
              ' bg-gray-200 rounded ' +
              (field.width || 'w-full')
            "
          ></div>
          } } }
        </div>

        <!-- Submit button skeleton -->
        <div class="h-12 bg-gray-200 rounded"></div>

        @if (type() === 'login') {
        <!-- Login specific: social login divider and buttons -->
        <div class="h-8 bg-gray-200 rounded w-3/4 mx-auto"></div>
        <div class="flex flex-col gap-3">
          <div class="h-12 bg-gray-200 rounded"></div>
          <div class="h-12 bg-gray-200 rounded"></div>
        </div>
        } @else if (type() === 'register') {
        <!-- Register specific: sign in link -->
        <div class="h-8 bg-gray-200 rounded w-3/4 mx-auto"></div>
        }
      </div>
    </div>
  `,
})
export class LoadingSkeletonComponent {
  type = input<SkeletonType>('login');
  customFields = input<
    Array<{
      type: 'single' | 'grid';
      height?: number;
      width?: string;
      columns?: number;
      items?: number;
    }>
  >([]);

  getArrayFromNumber(count: number): number[] {
    return Array(count).fill(0);
  }
}
